(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["craft-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('misa-video')) {
    customElements.define('misa-video', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.button = this.querySelector('[data-play-video]');
        if (!this.button) return;
        this.poster = this.querySelector('[data-video-poster]');
        this.error = this.querySelector('[data-video-error]');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        const options = {signal: this.controller.signal};
        this.button.addEventListener('click', () => this.play(true), options);
        this.motion.addEventListener('change', () => this.sync(), options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        if (this.hasAttribute('data-autoplay-on-scroll')) {
          this.observer = new IntersectionObserver(entries => {
            this.inView = entries[0].isIntersecting && entries[0].intersectionRatio >= .25;
            this.sync();
          }, {threshold: [0, .25]});
          this.observer.observe(this);
        }
      }
      sync() {
        if (this.inView && !document.hidden && !this.motion.matches && !this.userPaused) {
          this.play(false);
        } else if (this.video && !this.video.paused) {
          this.automaticPause = true;
          this.video.pause();
        }
      }
      async play(manual) {
        if (this.pending || (this.video && !this.video.paused)) return;
        if (!this.video) {
          this.append(this.querySelector('template').content.cloneNode(true));
          this.video = this.querySelector(':scope > video');
          const options = {signal: this.controller.signal};
          this.video.addEventListener('pause', () => {
            if (!this.automaticPause && !this.video.ended) this.userPaused = true;
            this.automaticPause = false;
          }, options);
          this.video.addEventListener('play', () => { this.userPaused = false; }, options);
        }
        if (manual) this.userPaused = false;
        else this.video.muted = true;
        this.pending = true;
        this.button.disabled = true;
        this.error.hidden = true;
        try {
          await this.video.play();
          this.poster.hidden = true;
          this.button.hidden = true;
          if (manual) { this.video.setAttribute('tabindex', '0'); this.video.focus(); }
          else if (!this.inView || document.hidden) { this.automaticPause = true; this.video.pause(); }
        } catch {
          this.button.hidden = false;
          this.error.hidden = !manual;
        } finally {
          this.pending = false;
          this.button.disabled = false;
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('misa-product-rail')) {
    customElements.define('misa-product-rail', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.track = this.querySelector('.product-rail__track');
        this.controls = [...this.querySelectorAll('[data-rail-direction]')];
        if (!this.track) return;
        const update = () => this.controls.forEach(button => {
          const atStart = this.track.scrollLeft <= 1;
          const atEnd = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 1;
          button.disabled = Number(button.dataset.railDirection) < 0 ? atStart : atEnd;
        });
        this.controls.forEach(button => button.addEventListener('click', () => {
          const card = this.track.firstElementChild;
          const step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap) : this.track.clientWidth;
          this.track.scrollBy({left:step * Number(button.dataset.railDirection),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        }, {signal:this.controller.signal}));
        this.track.addEventListener('scroll', update, {passive:true,signal:this.controller.signal});
        this.observer = new ResizeObserver(update);
        this.observer.observe(this.track);
        update();
      }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if(!customElements.get('misa-product'))customElements.define('misa-product',class extends HTMLElement{
    connectedCallback(){
      this.controller=new AbortController();
      this.addEventListener('click',event=>{
        const link=event.target.closest('[data-option-link]');
        if(!link||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
        event.preventDefault();this.changeVariant(link);
      },{signal:this.controller.signal});
      const buy=this.querySelector('[data-main-buy]'),sticky=this.querySelector('[data-sticky-buy]');
      if(buy&&sticky){this.observer=new IntersectionObserver(entries=>{const rect=entries[0].boundingClientRect;sticky.hidden=entries[0].isIntersecting||rect.top>0;},{threshold:0});this.observer.observe(buy);}
    }
    async changeVariant(link){
      this.request?.abort();this.request=new AbortController();this.setAttribute('aria-busy','true');this.querySelectorAll('[name="add"]').forEach(button=>button.disabled=true);
      const url=new URL(link.href),endpoint=new URL(url);endpoint.searchParams.set('section_id',this.dataset.sectionId);
      try{
        const response=await fetch(endpoint,{signal:this.request.signal});if(!response.ok)throw new Error();
        const page=new DOMParser().parseFromString(await response.text(),'text/html'),next=page.querySelector('misa-product');if(!next)throw new Error();
        if(next.dataset.variantId){url.searchParams.delete('option_values');url.searchParams.set('variant',next.dataset.variantId);}
        history.replaceState({},'',url);this.replaceWith(next);next.querySelector(`[data-option-key="${CSS.escape(link.dataset.optionKey)}"]`)?.focus({preventScroll:true});
      }catch(error){if(error.name!=='AbortError')location.assign(link.href);}
    }
    disconnectedCallback(){this.controller?.abort();this.request?.abort();this.observer?.disconnect();}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('misa-recommendations'))customElements.define('misa-recommendations',class extends HTMLElement{
    connectedCallback(){
      if(this.querySelector('section'))return;
      this.observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){this.observer.disconnect();this.load();}},{rootMargin:'300px'});
      this.observer.observe(this);
    }
    async load(){
      this.controller=new AbortController();
      try{const response=await fetch(this.dataset.url,{signal:this.controller.signal});if(!response.ok)return;const page=new DOMParser().parseFromString(await response.text(),'text/html'),section=page.querySelector('misa-recommendations>section');if(section)this.replaceChildren(section);}catch{}
    }
    disconnectedCallback(){this.observer?.disconnect();this.controller?.abort();}
  });

  } catch(e) { console.error(e); }
})();
})();
